// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"f25ebe9d","239":"20f7e0b1","667":"a71f6fba","977":"870a82d9"}[chunkId] + ".chunk.js";
};